import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=7a8313ac&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationBackButton: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/base/navigation/BackButton.vue').default,IconsMap: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/icons/Map.vue').default,IconsGlobe: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/icons/Globe.vue').default,IconsPhone: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/icons/Phone.vue').default,IconsMail: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/icons/Mail.vue').default,ShareLinks: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/base/ShareLinks.vue').default,VacatureBar: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/vacature/Bar.vue').default,VacatureInfoCard: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/vacature/InfoCard.vue').default,LayoutsSideView: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/layouts/SideView.vue').default,VacatureLoader: require('/data/www/vacaturebank.kngf.nl/kngf/nuxt/components/vacature/Loader.vue').default})
